import { isSameDay } from 'date-fns';
import { useMemo } from 'react';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';
import { getScheduleByDate } from 'shared/utils/schedules';

export const usePlannedOccurrenceForDate = (
  schedules: HabitSchedule[] | undefined | null,
  date: Timestamp,
) =>
  useMemo(() => {
    const schedule = getScheduleByDate(schedules, date);

    if (!schedule) {
      return;
    }

    return schedule.plannedOccurrences?.find(({ date: plannedDate }) =>
      isSameDay(plannedDate, date),
    );
  }, [date, schedules]);
